import React from "react";
import "./style.css";
import { useSession } from "../hooks/session";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const Title = ({ sessionId }) => {
  const { data, isLoading } = useSession(sessionId);

  if (isLoading) return <TitleText text={"Fetching pathway..."} />;

  return <TitleText text={data.title} />;
};

export default Title;

const TitleText = ({ text }) => {
  let navigate = useNavigate();
  return (
    <div className={"title"} title={"Back to Homepage"}>
      <div className={"backToHP"} onClick={() => navigate("/")}>
        <FontAwesomeIcon
          icon="fa-house"
          size="sm"
          color="#4169e1"
          style={{ placeSelf: "end center" }}
        />
        <FontAwesomeIcon
          icon="fa-left-long"
          size="sm"
          color="#4169e1"
          style={{ placeSelf: "start center" }}
        />
      </div>
      <div className={"textFitRelative"}>
        <div className={"textFitAbsolute"}>
          <h1
            className={"textFit"}
            style={{ fontSize: `${buildFontSize(text.length)}px` }}
          >
            {text}
          </h1>
        </div>
      </div>
    </div>
  );
};

const buildFontSize = (len) => {
  let fontSize;
  if (len < 30) {
    fontSize = 35;
  } else if (len < 60) {
    fontSize = 30;
  } else if (len < 90) {
    fontSize = 25;
  } else if (len < 120) {
    fontSize = 20;
  } else {
    fontSize = 15;
  }
  return fontSize;
};
